import { useMemo, useState } from 'react';
import { Dialog, useMediaQuery, IconButton } from '@mui/material';
import { Close, KeyboardBackspace } from '@mui/icons-material';
import Main from './Main';
import Update from './Update';
import ACSnackbar from '../../../components/ACSnackbar';
import ModalSlider from '../../../components/ModalSlider';

const useStyles = ({ isXS }) => ({
  imageWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: isXS ? '0px' : '8px',
  },
  dialogContainer: {
    padding: isXS ? '0px' : '10px',
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    width: isXS ? '' : '600px',
    height: 'auto',
    alignItems: 'center',
    background: '#FFFFFF',
    borderRadius: isXS ? '0px' : '15px',
    paddingTop: isXS ? '24px' : '24px',
    paddingBottom: isXS ? '0px' : '30px',
  },
});

export default function PrioritiesModal({ open, setIsOpen, survey }) {
  const [activeStep, setActiveStep] = useState(0);
  const [updateType, setUpdateType] = useState('');
  const [blockClosePopup, setBlockClosePopup] = useState(false);
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

  function handleClose() {
    if (blockClosePopup) {
      return;
    }
    setIsOpen(false);
    setActiveStep(0);
  }

  const steps = useMemo(() => {
    return [
      <Main
        setActiveStep={setActiveStep}
        survey={survey}
        setUpdateType={setUpdateType}
      />,
      <Update
        updateType={updateType}
        setBlockClosePopup={setBlockClosePopup}
        handleClose={handleClose}
        setIsSnackbarVisible={setIsSnackbarVisible}
        activeStep={activeStep}
      />,
    ];
  }, [survey, updateType, activeStep]);

  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const classes = useStyles({ isXS });

  return (
    <Dialog
      open={open}
      sx={classes.dialogContainer}
      fullScreen={isXS}
      PaperProps={{ sx: { borderRadius: { xxs: 0, sm: '10px' } } }}
      onClose={handleClose}
    >
      <ACSnackbar
        onClose={() => setIsSnackbarVisible(false)}
        open={isSnackbarVisible}
        severity="error"
        text={
          updateType === 'goal'
            ? 'Something went wrong updating the current challenge.'
            : 'Something went wrong creating the survey.'
        }
      />
      <div style={classes.dialog}>
        {isXS && (
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <Close />
          </IconButton>
        )}
        {activeStep > 0 && (
          <IconButton
            size="small"
            onClick={() => setActiveStep(0)}
            sx={{ position: 'absolute', top: 20, left: 20, zIndex: 10 }}
          >
            <KeyboardBackspace />
          </IconButton>
        )}
        <ModalSlider steps={steps} activeStep={activeStep} width={{
            xxs: '100%',
            xs: '500px',
            sm: '550px',
          }} />
      </div>
    </Dialog>
  );
}
